































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { JobListModule } from '@/store/modules/jobList';
import { AgencyModule } from '@/store/modules/agency';
import Alert from '@/components/Shared/Alert.vue'
import JobDto from '@/models/Jobs/JobDto'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobCreate from '@/components/Jobs/JobCreate.vue';
import JobStatus from '@/components/Jobs/Display/JobStatus.vue';
import JobListSearchCriteria from '@/components/Jobs/JobListSearchCriteria.vue';
import JobListSendJobs from '@/components/Jobs/JobListSendJobs.vue';
import JobStage from '@/models/Jobs/JobStage';

@Component({
	name: 'AgencyJobs',
  	components: { Alert, JobCreate, JobStatus, JobListSearchCriteria, JobListSendJobs }
})
export default class extends GiganautVue {

  JobStage = JobStage;
  stage: JobStage = JobStage.Undefined;

  async navigateToJob(id: string) {
    this.$router.push({ name: PageNames.AgencyJobDetails, params: { jobid: id } });
  }

  get loading() {
		return JobListModule.loading;
  }

  // Per-stage colour. Active button = filled; inactive = outlined in same colour.
  stageColor(s: JobStage): string {
    switch (s) {
      case JobStage.Undefined: return 'primary';
      case JobStage.Pending: return 'grey';
      case JobStage.Shortlisted:
      case JobStage.Interested:
      case JobStage.InterviewOne:
      case JobStage.InterviewTwoPlus:
      case JobStage.Offered: return 'orange';
      case JobStage.Placed: return 'green';
      default: return 'primary';
    }
  }

  setStage(stage: JobStage) {
    this.stage = stage;
  }

  async beforeMount() {
    await JobListModule.searchJobs();
  }
   
  private search = '';

  get jobs() {
    return JobListModule.jobs;
  }

  get searchOptionsVM() {
    return JobListModule.jobSearchViewModel;
  }

  get jobsAtPending() {
    return JobListModule.jobsAtPending;
  }

  get jobsAtShortlisted() {
    return JobListModule.jobsAtShortlisted;
  }

  get jobsAtInterested() {
    return JobListModule.jobsAtInterested;
  }

  get jobsAtInterviewOne() {
    return JobListModule.jobsAtInterviewOne;
  }

  get jobsAtInterviewTwoPlus() {
    return JobListModule.jobsAtInterviewTwoPlus;
  }

  get jobsAtOffered() {
    return JobListModule.jobsAtOffered;
  }

  get jobsAtPlaced() {
    return JobListModule.jobsAtPlaced;
  }

   private headers = [
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Branch', value: 'branchBrandName' },
    { text: 'Title', value: 'title'},
    { text: AppModule.currentAgencyContext.labels.company, value: 'companyBrandName'},
    { text: AppModule.currentAgencyContext.labels.location, value: 'locationBrandName'},
    { text: 'Status', value: 'status'},
    { text: 'Actions' },
  ]
}
